<template>
  <div>
    <slot
      :isRecording="isRecording"
      :recordingTime="recordingTime"
      :startRecording="startRecording"
      :stopRecording="stopRecording"
      :deleteRecording="deleteRecording"/>
  </div>
</template>

<script>
import Recorder from './lib/recorder';
import { convertTimeMMSS } from './lib/utils';

export default {
  name: 'Dictaphone',
  props: {
    mimeType: {
      type: String,
      default: 'audio/wav',
    },
    time: {
      type: Number,
      default: 10,
    },
  },
  data() {
    return {
      audioBlob: null,
      mediaRecorder: null,
      isRecording: false,
      recorder: new Recorder({
        onStart: () => {
          this.handleRecordStart();
        },
        afterStop: () => {
          this.handleRecordStop();
        },
        micFailed: (error) => {
          this.handleMicrophoneFailure(error);
        },
        time: this.time,
      }),
    };
  },
  computed: {
    recordingTime() {
      if (this.time && this.recorder.duration >= this.time * 60) {
        this.stopRecording();
      }
      return convertTimeMMSS(this.recorder.duration);
    },
  },
  watch: {
    isRecording(recording) {
      if (recording) {
        this.$emit('start', true);
      }
    },
  },
  methods: {
    async startRecording() {
      this.recorder.start();
    },
    stopRecording() {
      this.recorder.stop();
    },
    deleteRecording() {
      this.isRecording = false;
      setTimeout(() => {
        this.withoutSave = true;
        this.recorder.stop();
      }, 0);
    },
    handleRecordStart() {
      this.$emit('start');
      this.isRecording = true;
    },
    handleRecordStop() {
      if (!this.withoutSave) {
        const record = this.recorder.lastRecord();
        this.$emit('stop', record);
      } else {
        this.$emit('cancel');
      }
      this.isRecording = false;
      this.withoutSave = false;
    },
    handleMicrophoneFailure(error) {
      this.isRecording = false;
      this.$emit('error', error);
    },
  },
};
</script>

<style lang="scss" scoped>
.recording-process {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 100;
  cursor: initial;

  .record-panel {
    height: 100%;

    .time {
      // text-align: center;
      font-size: 14px;
      line-height: 0.93;
      color: $blackPrimary;

      .ticker {
        animation: blink 1s infinite linear;
        margin-left: 18px !important;
        margin-right: 9px !important;
      }
    }

    .record-button {
      cursor: pointer;
      margin-right: 4px;

      &:last-child {
        margin-right: 6px;
      }
    }
  }
}
</style>